import '../styles/globals.css';
import { appWithTranslation } from 'next-i18next';
import nextI18nConfig from '../next-i18next.config';
import { GoogleReCaptchaProvider } from '../components/recaptcha/GoogleReCaptchaProvider';
import AzureAppInsights from '../components/general/AzureAppInsights';
import { wrapper } from '../store/index';
import { Provider } from 'react-redux';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

const App = ({ Component, ...rest }) => {
  const { store, props } = wrapper.useWrappedStore(rest);

  const router = useRouter();

  useEffect(() => {
    const handleRouteChangeStart = () => {
      // Blur any focused element
      if (
        typeof window !== 'undefined' &&
        document.activeElement &&
        typeof document.activeElement.blur === 'function'
      ) {
        document.activeElement.blur();
      }

      // Target the newsletter form in the footer by class
      const newsletterForm = document.querySelector('.NewsletterModule form.form');
      if (newsletterForm && !newsletterForm.classList.contains('is-submitting')) {
        newsletterForm.reset();
      }
    };

    // Analytics on route change complete
    const handleRouteChangeComplete = () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'page_view',
        page_path: props?.pageProps?.metadata?.absolutePageUrl,
        page_location: window?.location?.href,
        page_title: props?.pageProps?.metadata?.pageTitle,
      });
    };

    router.events.on('routeChangeStart', handleRouteChangeStart);
    router.events.on('routeChangeComplete', handleRouteChangeComplete);

    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart);
      router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
  }, [router.events, props?.pageProps?.metadata?.absolutePageUrl, props?.pageProps?.metadata?.pageTitle]);

  return (
    <AzureAppInsights>
      <Provider store={store}>
        <GoogleReCaptchaProvider
          reCaptchaKey={process.env.RECAPTCHA_SITE_KEY}
          scriptProps={{
            async: true, // optional, default to false,
            defer: true, // optional, default to false
            appendTo: 'body', // optional, default to "head", can be "head" or "body",
            nonce: undefined,
          }}
        >
          <Component {...props.pageProps} />
        </GoogleReCaptchaProvider>
      </Provider>
    </AzureAppInsights>
  );
};

// https://github.com/i18next/next-i18next#unserializable-configs
export default appWithTranslation(App, nextI18nConfig);
